export default __webpack_public_path__ + "static/media/Square.beb8f326.png";